var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsersV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 13C11.1875 13 13 11.2188 13 9C13 6.8125 11.1875 5 9 5C6.78125 5 5 6.8125 5 9C5 11.2188 6.78125 13 9 13ZM9 6.5C10.375 6.5 11.5 7.625 11.5 9C11.5 10.4062 10.375 11.5 9 11.5C7.59375 11.5 6.5 10.4062 6.5 9C6.5 7.625 7.59375 6.5 9 6.5ZM10.5625 14.5H7.40625C4.40625 14.5 2 16.9375 2 19.9375C2 20.5312 2.46875 21 3.0625 21H14.9062C15.5 21 16 20.5312 16 19.9375C16 16.9375 13.5625 14.5 10.5625 14.5ZM3.5 19.5C3.71875 17.5625 5.375 16 7.40625 16H10.5625C12.5938 16 14.2188 17.5625 14.4688 19.5H3.5ZM16.9688 15H14.6562C16.0938 16.1875 17 17.9688 17 19.9375C17 20.3438 16.875 20.6875 16.6875 21H21C21.5312 21 22 20.5625 22 20C22 17.25 19.75 15 16.9688 15ZM15.5 13C17.4062 13 19 11.4375 19 9.5C19 7.59375 17.4062 6 15.5 6C14.6875 6 13.9688 6.28125 13.4062 6.71875C13.75 7.40625 14 8.1875 14 9C14 10.125 13.625 11.1562 13 11.9688C13.625 12.625 14.5 13 15.5 13Z",
    fill: "#0D3338"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersV2);
export default __webpack_public_path__ + "static/media/Users-v2.6eeb0cda573b1f33758c9d322b3827fe.svg";
export { ForwardRef as ReactComponent };